import { render, staticRenderFns } from "./ToppingList.vue?vue&type=template&id=25fcdf86&scoped=true&"
import script from "./ToppingList.vue?vue&type=script&lang=js&"
export * from "./ToppingList.vue?vue&type=script&lang=js&"
import style0 from "./ToppingList.vue?vue&type=style&index=0&id=25fcdf86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fcdf86",
  null
  
)

export default component.exports